module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "SOM",
    attrs: {
      "epub:type": "toc"
    }
  }, [_c('h1', {
    staticClass: "SOM_surtit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "Illustration",
      "id": "box_1e",
      "src": "images/box.jpg"
    }
  }), _c('br'), _vm._v(" "), _c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "Illustration",
      "id": "back_6",
      "src": "images/back.jpg"
    }
  })])]), _vm._v(" "), _c('h1', {
    staticClass: "SOM_titre",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre2"
    }
  }, [_vm._v("Getting the Most Out of "), _c('i', [_vm._v("The Twelve Disciples")])])]), _vm._v(" "), _c('div', {
    staticClass: "table",
    attrs: {
      "id": "tableau-001"
    }
  }, [_c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    staticStyle: {
      "border-collapse": "collapse",
      "border-spacing": "0px"
    },
    attrs: {
      "border": ""
    }
  }, [_c('colgroup', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('col', {
    staticStyle: {
      "width": "15%",
      "padding": "7px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "85%",
      "padding": "7px"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap_autre"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1"
    }
  }, [_c('span', {
    staticClass: "mev2"
  }, [_vm._v("ONE")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1"
    }
  }, [_vm._v("Andrew: Bringing Others to Jesus"), _c('br'), _c('span', {
    staticClass: "mev5"
  }, [_vm._v("JOHN 1:35–42")])])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap_autre"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev2"
  }, [_vm._v("TWO")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Simon Peter: Defending (and Rebuking) the Savior"), _c('br'), _c('span', {
    staticClass: "mev5"
  }, [_vm._v("MARK 1:16–20; 8:27–38")])])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap_autre"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev2"
  }, [_vm._v("THREE")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Matthew: Drawing in the Outcast"), _c('br'), _c('span', {
    staticClass: "mev5"
  }, [_vm._v("Matthew 9:9–13")])])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap_autre"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev2"
  }, [_vm._v("FOUR")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("James: Hating Our Enemies"), _c('br'), _c('span', {
    staticClass: "mev5"
  }, [_vm._v("Luke 9:51–56; Acts 12:1–2")])])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap_autre"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev2"
  }, [_vm._v("FIVE")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Philip: Learning to Trust"), _c('br'), _c('span', {
    staticClass: "mev5"
  }, [_vm._v("John 6:1–13")])])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap_autre"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev2"
  }, [_vm._v("SIX")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John: Seeking to Be the Greatest"), _c('br'), _c('span', {
    staticClass: "mev5"
  }, [_vm._v("Matthew 20:20–28")])])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap_autre"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev2"
  }, [_vm._v("SEVEN")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thomas: Leaving Doubt Behind"), _c('br'), _c('span', {
    staticClass: "mev5"
  }, [_vm._v("John 20:19–29")])])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap_autre"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev2"
  }, [_vm._v("EIGHT")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nathanael: Developing Spiritual Insight"), _c('br'), _c('span', {
    staticClass: "mev5"
  }, [_vm._v("John 1:43–51")])])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap_autre"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev2"
  }, [_vm._v("NINE")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Judas Iscariot: Turning Away"), _c('br'), _c('span', {
    staticClass: "mev5"
  }, [_vm._v("Matthew 26:14–30, 47–50; 27:1–10")])])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap_autre"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev2"
  }, [_vm._v("TEN")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three Others: Faithful to the End"), _c('br'), _c('span', {
    staticClass: "mev5"
  }, [_vm._v("Luke 18:18–30")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Leader’s Notes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Should We Study Next?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdf"
  }, [_c('span', {
    attrs: {
      "href": "#/fin_acheve",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-029e4e6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sommaire.vue
// module id = 60
// module chunks = 0